import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import useShippingCountry from '~/composables/useShippingCountry';
import { useWorkshop } from '~/composables/_next/useWorkshop';
import { useCart } from '~/composables/useCart';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useBooxi() {
  var _useShippingCountry = useShippingCountry(),
    currentCountry = _useShippingCountry.country;
  var loaded = useState('booxi-loaded', function () {
    return false;
  });
  var _useCart = useCart(),
    cart = _useCart.cart;
  var _useWorkshop = useWorkshop(),
    clearSavedCart = _useWorkshop.clearSavedCart,
    saveCart = _useWorkshop.saveCart;
  var countryToken = computed(function () {
    var _currentCountry$value, _tokens$countryCode;
    var countryCode = (_currentCountry$value = currentCountry.value) !== null && _currentCountry$value !== void 0 ? _currentCountry$value : '';
    var tokens = {
      FR: process.env.BOOXI_SHOP_ID_FR,
      BE: process.env.BOOXI_SHOP_ID_BE
    };
    return countryCode ? (_tokens$countryCode = tokens[countryCode]) !== null && _tokens$countryCode !== void 0 ? _tokens$countryCode : '' : '';
  });

  /**
   * Loads Booxi script (workshop booking provider).
   */
  function loadBooxi() {
    if (process.server) throw new Error('Booxi is only available client side');
    if (loaded.value) return true;
    return new Promise(function (resolve, reject) {
      if (document.getElementById('BooxiIframeManager')) {
        resolve(true);
      }
      var script = document.createElement('script');
      script.id = 'BooxiIframeManager';
      script.src = 'https://www.booxi.eu/booknow/booknow.js';
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.onload = function () {
        resolve(true);
      };
      script.onerror = function (error) {
        console.error('Booxi script could not be loaded');
        reject(error);
      };
      document.head.appendChild(script);
    });
  }

  /**
   * Opens Booxi modal.
   *
   * @param      {string}        arg1.shopId                              The shop identifier
   * @param      {string}        arg1.bookingFlow                         The booking flow
   * @param      {string}        arg1.serviceTags                         The service tags
   * @param      {function}        arg1.onClose                             On close callback function
   */
  function openBooxi(_ref) {
    var shopId = _ref.shopId,
      bookingFlow = _ref.bookingFlow,
      serviceTags = _ref.serviceTags,
      onClose = _ref.onClose;
    if (!shopId) {
      shopId = countryToken.value;
    }
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var booxi = window.BookNow;
    booxi.open({
      apiKey: shopId,
      bookingFlow: bookingFlow,
      serviceTags: serviceTags,
      language: locale,
      onClose: onClose
    });
    clearSavedCart();
    if (cart.value) {
      var _cart$value$lineItems;
      saveCart((_cart$value$lineItems = cart.value.lineItems) === null || _cart$value$lineItems === void 0 ? void 0 : _cart$value$lineItems.filter(function (item) {
        return !!item.variant;
      }).map(function (item) {
        return {
          product: {
            id: item.variant.id,
            sku: item.variant.sku
          },
          quantity: item.quantity
        };
      }));
    }
  }
  return {
    loadBooxi: loadBooxi,
    openBooxi: openBooxi
  };
}